var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.files),function(file){return _c('div',{key:file.path},[_c('a',{attrs:{"target":"_blank","href":file.path}},[_vm._v(_vm._s(file.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }